import animateStripTrack from './animateStripTrack';
let initialized = false;

export default function animateMobileStrip() {
    if (initialized) return;
    initialized = true;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const strips = Array.from(document.querySelectorAll<HTMLElement>('.homepage-hero-strip, .bf-about-stats'));
    const cleanups: (() => void)[] = [];

    const rebuild = () => {
        cleanups.splice(0).forEach(cleanup => cleanup());
        strips.forEach(strip => {
            const originals = Array.from(strip.querySelectorAll<HTMLElement>('.homepage-hero-strip__item, .bf-about-stats__item'));
            if (!originals.length) return;
            const mobile = document.createElement('div');
            mobile.className = 'bf-mobile-strip';
            const track = document.createElement('div');
            track.className = 'bf-mobile-strip__track';
            const group = document.createElement('div');
            group.className = 'bf-mobile-strip__group';
            const addEntries = (duplicates: boolean) => originals.forEach(original => {
                const entry = original.cloneNode(true) as HTMLElement;
                entry.className = 'bf-mobile-strip__item';
                entry.removeAttribute('id');
                entry.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
                if (duplicates) { entry.setAttribute('aria-hidden', 'true'); entry.inert = true; }
                group.appendChild(entry);
            });
            addEntries(false);
            track.appendChild(group);
            mobile.appendChild(track);
            strip.appendChild(mobile);
            strip.classList.add('bf-mobile-strip-active');
            // One full sequence must span the viewport before its duplicate begins.
            while (group.getBoundingClientRect().width < mobile.clientWidth) addEntries(true);
            const duplicate = group.cloneNode(true) as HTMLElement;
            duplicate.setAttribute('aria-hidden', 'true');
            duplicate.inert = true;
            track.appendChild(duplicate);
            const animation = !reducedMotion.matches ? animateStripTrack(track, false, Number(strip.dataset.duration ?? 16)) : null;
            const pause = () => animation?.pause();
            const play = () => animation?.play();
            mobile.addEventListener('pointerenter', pause);
            mobile.addEventListener('pointerleave', play);
            cleanups.push(() => {
                animation?.kill();
                mobile.remove();
                strip.classList.remove('bf-mobile-strip-active');
            });
        });
    };
    let frame = 0;
    let width = window.innerWidth;
    window.addEventListener('resize', () => {
        if (width === window.innerWidth) return;
        width = window.innerWidth;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(rebuild);
    });
    reducedMotion.addEventListener('change', rebuild);
    rebuild();
    document.fonts.ready.then(rebuild);
}
